exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".save-dialog{position:fixed;bottom:0;left:0;width:100%;background-color:rgba(0,0,0,.9);height:90px;z-index:1000;display:flex;align-items:center;justify-content:center}button.save{background-color:#001478;color:#fff}button.cancel,button.save{padding:15px 25px;border:none;margin:0 10px}button.cancel{background-color:#fff;color:#000}button.primary,div.primary{background-color:#001478;color:#fff;border:none;margin:0 10px}button.primary:hover,div.primary:hover{background-color:#09f}button.primary.primary-right,div.primary.primary-right{float:right}button.primary:disabled,div.primary:disabled{opacity:.5}button.primary:disabled:hover,div.primary:disabled:hover{background-color:#001478}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/saveDialog/saveDialog.scss
// module id = 512
// module chunks = 0